import { Stack } from '@mui/material';

import {
  ConfigurationDetails,
  ConfigurationDetailsProps,
  Metrics,
  MetricsProps,
} from './components';

type ReferralProgramDetailsPageProps = ConfigurationDetailsProps & {
  metrics: MetricsProps;
};

export const ReferralProgramDetailsPage = (props: ReferralProgramDetailsPageProps) => {
  const { metrics, senderAward, receiverAward, qualifyingEvent, marketingContents } = props;

  return (
    <Stack spacing={1}>
      <ConfigurationDetails
        senderAward={senderAward}
        receiverAward={receiverAward}
        qualifyingEvent={qualifyingEvent}
        marketingContents={marketingContents}
      />
      <Metrics {...metrics} />
    </Stack>
  );
};
